
<div autocomplete="off" class="login-form">
<!--  <img src="assets/images/xcde.png" alt="FXCLR" class="img-center mr-5 pt-4" width="120">-->
  <h6 class="text-center" translate>Please fill out the following fields to login:</h6>
  <form class="text-center" *ngIf="!newPasswordRequired">
    <div class="form-group">
      <input type="text"
             class="form-control"
             placeholder="{{'labelUserName' | translate}}"
             autocapitalize="none"
             spellcheck="false"
             autocomplete="off"
             autocorrect="off"
             autocorrect="none"
             [readonly]="isReadOnly"
             name="username"
             id="username"
             [(ngModel)]="username"
             required
      />
    </div>
    <div class="form-group">
      <input type="password"
             class="form-control"
             placeholder="{{'labelPassword' | translate}}"
             autocapitalize="none"
             autocorrect="off"
             autocomplete="new-password"
             autocorrect="none"
             name="password"
             [(ngModel)]="password"
             required
      />
    </div>
    <div class="form-group text-center">
      <button class="btn btn-info mt-5" name="loginButton" translate (click)="login()" [disabled]="!username || !password || !isProtocolsMatch"><i class="fa fa-lg fa-sign-in"></i> buttonLoginLabel</button>
    </div>
    <mat-error *ngIf="!isProtocolsMatch">
      Server mismatch
    </mat-error>
  </form>


  <form class="text-center" *ngIf="newPasswordRequired">
    <div class="form-group">
      <input type="password"
             class="form-control"
             placeholder="{{'labelOldPassword' | translate}}"
             autocapitalize="none"
             spellcheck="false"
             autocomplete="off"
             autocorrect="off"
             autocorrect="none"
             [readonly]="isReadOnly"
             name="username"
             [(ngModel)]="password"
             required
      />
    </div>
    <div class="form-group">
      <input type="password"
             class="form-control"
             placeholder="{{'labelNewPassword' | translate}}"
             autocapitalize="none"
             autocorrect="off"
             autocomplete="new-password"
             autocorrect="none"
             name="password"
             [(ngModel)]="newPassword"
             required
      />
    </div>
    <div class="form-group">
      <input type="password"
             class="form-control"
             placeholder="{{'labelNewPasswordAgain' | translate}}"
             autocapitalize="none"
             autocorrect="off"
             autocomplete="new-password"
             autocorrect="none"
             name="password"
             [(ngModel)]="confirmNewPassword"
             required
      />
    </div>
    <div class="form-group text-center">
      <button class="btn btn-info mt-5" name="loginButton" translate (click)="login()" [disabled]="!username || !password || !isProtocolsMatch"><i class="fa fa-lg fa-sign-in"></i> buttonLoginLabel</button>
    </div>
    <mat-error *ngIf="!isProtocolsMatch">
      Server mismatch
    </mat-error>
  </form>

  <!--      <p><a [routerLink]="'/register'" class="text-white">Create an account</a></p>-->

</div>




